<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><span><a id="page_viii"></a>DEDICATION</span></p>
<p class="dedicationa"><span><i>Dedicated to the organic pioneers who have paved the way before us. With deep gratitude</i>.</span></p>
<p class="dedicationb"><span><i>And to young agrarians who are now changing the face of agriculture. We have not only the choice to do things differently, but the means as well</i>.</span></p>
<p class="image0"><span><img alt="" height="65" src="Images/fviii-01.jpg" width="59"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?1293421b